// extracted by mini-css-extract-plugin
module.exports = {"trigger":"CredentialExpirationStatus_trigger__2wMEX","tooltip":"CredentialExpirationStatus_tooltip__2wiP2"};